import React from 'react';

export const PageTitle = (props) => {
  return (
    <div className={`${props.className ?? ''} pageTitle`}>
      {props.children}
    </div>
  );
};
